import { styled, TextField } from '@mui/material';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInput-underline:before': {
    borderColor: theme.palette.divider
  }
}));

export { StyledTextField };
